import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.search.js";
import DownFileList from "@/components/DownFileList/index.vue";
import { saveAs } from "@/hooks/downUrl";
import Breads from "@/components/Breads/index.vue";
import { useRoute } from "vue-router";
import { defineComponent, reactive, ref } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { changeInfoTotal } from "@/hooks/changeInfoTotal";
import { useStore } from "vuex";
import Cookies from "js-cookie";
export default defineComponent({
  name: "AtDetail",
  components: {
    Breads: Breads,
    DownFileList: DownFileList
  },
  setup: function setup() {
    var videos = ref('');
    var clow = ref("收藏");
    var col = ref(false);

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var detail = reactive({
      list: {
        videoUrl: '',
        newsId: "",
        title: "",
        attachmentId: '',
        content: '',
        richText: ''
      },
      allPath: [{
        path: "",
        name: "内容详情",
        query: {}
      }],
      search: {
        collectionId: ""
      },
      dlist: [{
        realName: "",
        attachmentId: ""
      }],
      moduleId: "",
      imgUrl: ""
    });

    function test(val) {
      console.log(val);
    }

    function test2(val, callback) {
      console.log(val);
      callback();

      if (sessionStorage.getItem("user")) {
        IdowCollect(JSON.stringify({
          type: 2,
          title: detail.list.title,
          category: 3,
          contentId: detail.list.newsId
        }));
      }
    }

    function IdowCollect(_x) {
      return _IdowCollect.apply(this, arguments);
    }

    function _IdowCollect() {
      _IdowCollect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val) {
        var lis;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["collect"](val);

              case 2:
                lis = _context.sent;

                if (lis.code == 0) {
                  console.log(55555);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _IdowCollect.apply(this, arguments);
    }

    var store = useStore(); //详情

    function newDetails(_x2, _x3) {
      return _newDetails.apply(this, arguments);
    }

    function _newDetails() {
      _newDetails = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(val, name) {
        var lis, nums;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api[name](val);

              case 2:
                lis = _context2.sent;

                if (lis.code == 0) {
                  detail.list = lis.data;

                  if (detail.list.content) {
                    detail.list.content = detail.list.content.replace("_thn", "");
                  } else {
                    if (detail.list.content == "") {
                      detail.list.content = detail.list.content.replace("_thn", "");
                    } else {
                      detail.list.richText = detail.list.richText.replace("_thn", "");
                    }
                  }

                  detail.moduleId = lis.data.moduleId;
                  detail.imgUrl = lis.data.imgUrl;
                  videos.value = process.env.VUE_APP_BASE_URL + detail.list.videoUrl;

                  if (lis.data.attachmentId) {
                    download({
                      ids: lis.data.attachmentId
                    });
                  }

                  if (store.state.user.user.userId && Cookies.get("token")) {
                    if (lis.data.columnId) {
                      changeInfoTotal(0, "\u65B0\u95FB\uFF1A".concat(detail.list.title), 2);
                    }

                    if (route.query.nam) {
                      nums = 6;

                      if (route.query.nam != "资料下载") {
                        if (route.query.nam == "在线学习") {
                          nums = 3;
                          changeInfoTotal(0, "".concat(route.query.nam, "\uFF1A").concat(detail.list.title), nums);
                        }

                        if (route.query.nam == "三会一课") {
                          nums = 7;
                          changeInfoTotal(0, "".concat(route.query.nam, "\uFF1A").concat(detail.list.title), nums);
                        }

                        if (route.query.nam == "两学一做") {
                          nums = 8;
                          changeInfoTotal(0, "".concat(route.query.nam, "\uFF1A").concat(detail.list.title), nums);
                        }

                        if (route.query.nam == "规章制度") {
                          nums = 9;
                          changeInfoTotal(0, "".concat(route.query.nam, "\uFF1A").concat(detail.list.title), nums);
                        }

                        if (route.query.nam == "困难帮扶") {
                          nums = 10;
                          changeInfoTotal(0, "".concat(route.query.nam, "\uFF1A").concat(detail.list.title), nums);
                        }

                        if (route.query.nam == "表彰与处分") {
                          nums = 11;
                          changeInfoTotal(0, "".concat(route.query.nam, "\uFF1A").concat(detail.list.title), nums);
                        }
                      }
                    }
                  }

                  if (Cookies.get("token")) {
                    InquireCollect();
                  }
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _newDetails.apply(this, arguments);
    }

    var route = useRoute();

    function de() {
      var a = {};
      var b = route.query.newsId;
      var name = route.query.interfaceName;
      var pass = Number(route.query.pass);

      if (pass) {
        for (var item in route.query) {
          if (item != "interfaceName" && item != "pass") {
            a = item + "=" + route.query[item];
          }
        }

        newDetails(a, name);
      } else {
        newDetails(b, name);
      } //  let allD = String(route.query.name)


      var que = {};

      if (route.query.name) {
        que = {
          stair: route.query.stai,
          son: route.query.son
        };
      }

      if (route.query.name) {
        detail.allPath.unshift({
          path: "multiColumn",
          name: String(route.query.name),
          query: que
        });
      }
    }

    de();
    var downFileList = ref(null); //下载附件列表

    function download(_x4) {
      return _download.apply(this, arguments);
    } //下载


    function _download() {
      _download = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(val) {
        var lis, ids;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["download"](val);

              case 2:
                lis = _context3.sent;

                if (lis.code == 0) {
                  detail.dlist = lis.data;
                  ids = String(detail.dlist[0].attachmentId);
                  detail.dlist.forEach(function (item, index) {
                    if (index != 0) {
                      ids = ids + "," + String(item.attachmentId);
                    }
                  });
                  downFileList.value && downFileList.value["showList"]({
                    type: "ids",
                    value: ids
                  });
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _download.apply(this, arguments);
    }

    function dow(val) {
      collectdow();
      saveAs(val.attachmentId);
      changeInfoTotal(detail.list.newsId, "\u4E0B\u8F7D:".concat(detail.list.title), 6);
    } //查收藏


    function InquireCollect() {
      return _InquireCollect.apply(this, arguments);
    }

    function _InquireCollect() {
      _InquireCollect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var lis;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["InquireCollect"]({
                  category: route.query.category,
                  contentId: route.query.newsId,
                  type: 1
                });

              case 2:
                lis = _context4.sent;

                if (lis.code == 0) {
                  if (lis.data) {
                    col.value = true;
                    clow.value = "取消";
                  } else {
                    col.value = false;
                    clow.value = "收藏";
                  }

                  if (lis.data) {
                    detail.search = lis.data; // 
                  }
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _InquireCollect.apply(this, arguments);
    }

    function collectdow() {
      return _collectdow.apply(this, arguments);
    } //收藏


    function _collectdow() {
      _collectdow = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["collect"](JSON.stringify({
                  category: route.query.category,
                  contentId: detail.list.newsId,
                  title: detail.list.title,
                  type: 2
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _collectdow.apply(this, arguments);
    }

    function collect() {
      return _collect.apply(this, arguments);
    }

    function _collect() {
      _collect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var lis, _lis;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (col.value) {
                  _context6.next = 7;
                  break;
                }

                _context6.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["collect"](JSON.stringify({
                  category: route.query.category,
                  contentId: detail.list.newsId,
                  title: detail.list.title,
                  type: 1,
                  moduleId: detail.moduleId,
                  imgUrl: detail.imgUrl
                }));

              case 3:
                lis = _context6.sent;

                if (lis.code == 0) {
                  changeInfoTotal(detail.list.newsId, "\u6536\u85CF\uFF1A".concat(detail.list.title), 4);
                  InquireCollect();
                }

                _context6.next = 11;
                break;

              case 7:
                _context6.next = 9;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["delCollect"](detail.search.collectionId);

              case 9:
                _lis = _context6.sent;

                if (_lis.code == 0) {
                  InquireCollect();
                }

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _collect.apply(this, arguments);
    }

    return {
      col: col,
      detail: detail,
      route: route,
      de: de,
      newDetails: newDetails,
      download: download,
      dow: dow,
      collect: collect,
      InquireCollect: InquireCollect,
      clow: clow,
      collectdow: collectdow,
      test: test,
      test2: test2,
      downFileList: downFileList,
      IdowCollect: IdowCollect,
      videos: videos
    };
  }
});